import axios, { AxiosError, AxiosResponse } from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { RootState } from "data-handler/rootReducer";

const MV_REFRESH_LOG_REQUEST = "schoolconnect/mvRefreshLog/REQUEST";
const MV_REFRESH_LOG_SUCCESS = "schoolconnect/mvRefreshLog/SUCCESS";
const MV_REFRESH_LOG_FAILURE = "schoolconnect/mvRefreshLog/FAILURE";

type MVRefreshLogEntry = Record<string, any>;

type State = {
  fetching: boolean;
  error: AxiosError | null;
  entries: MVRefreshLogEntry[];
};

type RequestAction = {
  type: typeof MV_REFRESH_LOG_REQUEST;
};

type SuccessAction = {
  type: typeof MV_REFRESH_LOG_SUCCESS;
  data: MVRefreshLogEntry[];
};

type FailureAction = {
  type: typeof MV_REFRESH_LOG_FAILURE;
  error: AxiosError;
};

type Action = RequestAction | SuccessAction | FailureAction;

const initialState: State = {
  fetching: false,
  error: null,
  entries: [],
};

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case MV_REFRESH_LOG_REQUEST:
      return { ...state, fetching: true, error: null };
    case MV_REFRESH_LOG_SUCCESS:
      return { ...state, fetching: false, error: null, entries: action.data };
    case MV_REFRESH_LOG_FAILURE:
      return { ...state, fetching: false, error: action.error };
    default:
      return state;
  }
};

const persistedReducer = persistReducer(
  {
    key: "mvRefreshLog",
    storage,
    blacklist: ["fetching", "error"],
  },
  reducer
);

export default persistedReducer;

function fetchMVRefreshLog() {
  const url = `${process.env.REACT_APP_API_URL}/mv-refresh-log/`;
  return axios({ method: "GET", url });
}

export function* mvRefreshLogSagaWorker(_action: RequestAction) {
  try {
    const response: AxiosResponse = yield call(fetchMVRefreshLog);
    const data: MVRefreshLogEntry[] = response.data ?? [];
    yield put({ type: MV_REFRESH_LOG_SUCCESS, data });
  } catch (error) {
    yield put({ type: MV_REFRESH_LOG_FAILURE, error });
  }
}

export function* mvRefreshLogSagaWatcher() {
  yield takeLatest(MV_REFRESH_LOG_REQUEST, mvRefreshLogSagaWorker);
}

export const requestMVRefreshLog = (): RequestAction => ({
  type: MV_REFRESH_LOG_REQUEST,
});

export const getMVRefreshLog = (state: RootState): MVRefreshLogEntry[] =>
  state.mvRefreshLog?.entries ?? [];

export const getIsMVRefreshLogFetching = (state: RootState): boolean =>
  state.mvRefreshLog?.fetching ?? false;

export const getMVRefreshLogError = (state: RootState): AxiosError | null =>
  state.mvRefreshLog?.error ?? null;
